import React from 'react';
import EarliestDates from './EarliestDates';
import MonthCalendar from './MonthCalendar';
import TimeSlotPicker from './TimeSlotPicker';

/** Date (earliest + calendar) and time selection — shared by booking and rescheduling. */
export default function BookingScheduler({ picker }) {
  return (
    <>
      <section className="booking__section">
        <h2 className="booking__label">Date</h2>
        <p className="booking__hint">Earliest available</p>
        <EarliestDates
          items={picker.earliest.items}
          loading={picker.earliest.loading}
          selected={picker.selectedDate}
          onSelect={picker.selectDate}
        />
        <MonthCalendar
          month={picker.month}
          dayMap={picker.days.map}
          loading={picker.days.loading}
          selected={picker.selectedDate}
          onSelect={picker.selectDate}
          onPrev={picker.prevMonth}
          onNext={picker.nextMonth}
          canPrev={picker.canPrevMonth}
          canNext={picker.canNextMonth}
        />
      </section>
      <TimeSlotPicker
        date={picker.selectedDate}
        periods={picker.periods}
        period={picker.period}
        onPeriodChange={picker.setPeriod}
        selectedTime={picker.selectedTime}
        onSelectTime={picker.setSelectedTime}
        totalOpen={picker.totalOpen}
        loading={picker.slots.loading || !picker.selectedDate}
      />
    </>
  );
}
